import * as z from "zod";

export const TranslatableMoneyParamSchema = z.object({
  type: z.literal("money"),
  amount: z.number(),
  currency: z.string(),
});

export type TranslatableMoneyParam = z.infer<
  typeof TranslatableMoneyParamSchema
>;

/**
 * Text stored now and translated when it is read. Params may nest TranslatableText.
 */
export interface TranslatableText {
  key: string;
  params?: Record<string, TranslatableParam> | null;
}

/** Opt-in translated interpolation; same stored shape as TranslatableText. */
export type TranslateParam = TranslatableText;

export type TranslatableParam =
  | string
  | number
  | boolean
  | null
  | TranslatableMoneyParam
  | TranslatableText;

export const TranslatableTextSchema: z.ZodType<TranslatableText> = z.lazy(() =>
  z.object({
    key: z.string(),
    params: z.record(z.string(), TranslatableParamSchema).nullish(),
  }),
);

export const TranslatableParamSchema: z.ZodType<TranslatableParam> = z.lazy(() =>
  z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.null(),
    TranslatableMoneyParamSchema,
    TranslatableTextSchema,
  ]),
);

export function isTranslatableMoneyParam(
  value: unknown,
): value is TranslatableMoneyParam {
  return (
    typeof value === "object" &&
    value !== null &&
    "type" in value &&
    value.type === "money"
  );
}

export function isTranslatableText(value: unknown): value is TranslatableText {
  return (
    typeof value === "object" &&
    value !== null &&
    !isTranslatableMoneyParam(value) &&
    "key" in value &&
    typeof value.key === "string"
  );
}
